import React, { useEffect, useState } from "react";

import { Box, makeStyles, Typography } from "@material-ui/core";
import { Theme } from "@material-ui/core/styles";

import Navigation from "../../components/Navigation/Navigation";
import Container from "../../components/Container";
import waitingPeople from "../../assets/images/waiting.png";
import LightPurpleContainer from "../../components/LightPurpleContainer";
import RequestItem from "./components/RequestItem";
import NoRequests from "./components/NoRequests";
import { ReviewRequestItem } from "../../types/hospital";
import { getRequests } from "../../api/hospital";
import RodaRequest from "./RodaRequest";
import MetaDecorator from "../../components/MetaDecorator";

const useStyles = makeStyles((theme: Theme) => ({
  img: {
    width: "70rem",
    marginTop: theme.spacing(6),
    [theme.breakpoints.down("xs")]: {
      width: "20rem",
    },
  },
  margin: {
    margin: theme.spacing(5, 0, 6, 0),
  },
  gap: {
    display: "grid",
    gap: theme.spacing(6.5),
  },
}));

export default function RodaRequestsList() {
  const classes = useStyles();
  const [requests, setRequests] = useState<ReviewRequestItem[]>([]);
  const [selectedRequest, setSelectedRequest] = useState<number>(0);
  const [selectedRequestName, setSelectedRequestName] = useState<string>("");

  useEffect(() => {
    async function fetchData() {
      const response = await getRequests();
      setRequests(response.data.requests);
    }

    fetchData();
  }, [selectedRequest]);

  function handleOpenRequest(hospitalId: number, hospitalName: string) {
    setSelectedRequest(hospitalId);
    setSelectedRequestName(hospitalName);
  }

  return (
    <>
      <MetaDecorator />
      <Navigation setSelectedRequest={setSelectedRequest} />
      <Box pb={10}>
        <Container>
          {!selectedRequest && (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <img
                  src={waitingPeople}
                  alt="waiting people"
                  className={classes.img}
                />
              </div>
              {!requests.length && <NoRequests />}
              {!!requests.length && (
                <>
                  <Typography variant="h4" className={classes.margin}>
                    Zahtjevi na čekanju ({requests.length})
                  </Typography>
                  <LightPurpleContainer>
                    <div className={classes.gap}>
                      {requests.map((request, index) => (
                        <React.Fragment key={index}>
                          <RequestItem
                            hospitalId={request.hospitalId}
                            hospitalName={request.hospitalName}
                            handleOpenRequest={handleOpenRequest}
                          />
                        </React.Fragment>
                      ))}
                    </div>
                  </LightPurpleContainer>
                </>
              )}
            </>
          )}

          {!!selectedRequest && (
            <RodaRequest
              redirectToRequestsList={() => setSelectedRequest(0)}
              hospitalId={selectedRequest}
              hospitalName={selectedRequestName}
            />
          )}
        </Container>
      </Box>
    </>
  );
}
